import {
    AfterViewInit,
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChange
} from '@angular/core';
import {PointOfSaleDto} from "../../pointOfSale/point-of-sale-dto";
import {LoggerService} from "../../../core/logger.service";
import {GAService} from "../../../root/ga/ga.service";
import {SpecialPointOfSaleService} from "../../pointOfSale/special-point-of-sale.service";

@Component({
    selector: 'phone-container',
    templateUrl: './phone-container.component.html'
})
export class PhoneContainerComponent implements OnInit, AfterViewInit, OnChanges{

    @Input() errors;
    @Input() dto:PointOfSaleDto;
    @Input() countryId:number;
    @Input() hasOtherDeliveryMessage:boolean=false;
    @Input() phonePrefix:string;
    @Input() freeLine:string[];
    @Input() isValidLocation:boolean;

    specialPOS = new SpecialPointOfSaleService();
    isFreeLine1:boolean=false;
    isFreeLine2:boolean=false;
    hideAddPhone:boolean=false;
    deletePhoneIcon:boolean=false;
    digitPhoneError1:boolean = false;
    digitPhoneError2:boolean = false;
    incompletePhone1:boolean = false;
    incompletePhone2:boolean = false;
    phoneOne:string="";
    phoneTwo:string="";
    isReqPhoneCompleted:boolean=false;

    public mask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

    constructor(private logger: LoggerService, private gaService: GAService) {
    }

    ngAfterViewInit(): void {
    }

    ngOnChanges(changes:  {[propKey: string]: SimpleChange}): void {
        let currentErrors = changes['errors'] ? changes['errors'].currentValue : undefined;
        let isValid = changes['isValidLocation'] ? changes['isValidLocation'].currentValue : undefined;
        if(currentErrors){
            if(currentErrors.phoneRequiredDigit){
                this.digitPhoneError1 = true;
            }
            if(currentErrors.phoneRequiredMissing) {
                this.incompletePhone1 = true;
            }
            if(currentErrors.phoneOptionalDigit) {
                this.digitPhoneError2 = true;
            }
        }

        if(isValid === false) {
            this.phoneOne= ""
            this.phoneTwo= "";
            this.isReqPhoneCompleted = false;
            this.hideAddPhone = false;
            this.isFreeLine1 = false;
            this.isFreeLine2 = false;
        }
    }

    ngOnInit(): void {
        this.logger.info('PhoneContainer: logger.info()' + JSON.stringify(this.dto));
        this.phoneInit();
    }

    phoneInit() {
        const phoneReq:string = this.dto.pickupIndications.phoneRequired;
        const phoneOpt:string = this.dto.pickupIndications.phoneOptional;

        if(phoneReq) {
            this.phoneOne = phoneReq.split(" ")[1];
            this.isFreeLine(1, this.phoneOne.split('-', 1).join());
            this.isReqPhoneCompleted = true;
        }
        if(phoneOpt) {
            this.phoneTwo = phoneOpt.split(" ")[1];
            this.isFreeLine(2, this.phoneTwo.split('-', 1).join());
            this.hideAddPhone = true;
        }
    }

    /*This method has to add more logic to recognize the proper phone number
    and can be use in the validations previous to change the dto object*/
    checkingPhone(value:string, phoneId) {
        let phone = value.split('_').join('');

        if(phone.length>0 && phone.length < 12){
            if(phoneId === 1){
                this.digitPhoneError1 = true;
                this.isFreeLine1 = false;
            }
            else{
                this.digitPhoneError2 = true;
                this.isFreeLine2 = false;
            }
        }
        this.createPhone(value, phoneId===1);
    }

    onKeyUpPress(event, phoneId){
        let errorPhone = event.split('_').join('');
        let ele = event.split('-',1).join('');

        this.checkingIsPhoneRequiredCompleted(errorPhone, phoneId);

        if(errorPhone.length <= 12) {
            if (phoneId === 1) {
                this.digitPhoneError1 = false;
                this.incompletePhone1 = false;
            } else {
                this.digitPhoneError2 = false;
                this.incompletePhone2 = false;
            }
        }

        this.isFreeLine(phoneId, ele);
    }

    isFreeLine(phoneId, ele) {
        if(this.freeLine){
            if(ele.length === 3) {
                if(phoneId === 1){
                    this.isFreeLine1 = this.freeLine.includes(ele);
                }
                else {
                    this.isFreeLine2 = this.freeLine.includes(ele);
                }

            } else if(ele.length < 3){
                if(phoneId === 1){
                    this.isFreeLine1 = false;
                }
                else{
                    this.isFreeLine2 = false;
                }
            }
        }
    }

    checkingIsPhoneRequiredCompleted(errorPhone, phoneId) {
        this.isReqPhoneCompleted = phoneId === 1 && errorPhone.length === 12;
    }

    addPhone() {
        if(this.isReqPhoneCompleted) {
            this.hideAddPhone = true;
            this.deletePhoneIcon = true;
        }
        this.specialAirportNotify("phone", ["add"])
    }

    deletePhone() {
        this.hideAddPhone = false;
        this.deletePhoneIcon = false;
        this.dto.pickupIndications.phoneOptional = "";
        this.digitPhoneError2 = false;
        this.incompletePhone2 = false;
        this.isFreeLine2 = false;
        this.phoneTwo = "";

        let phoneTemp = this.dto.pickupIndications.phoneRequired.split(" ")[1];
        let errorPhone = phoneTemp.split('_').join('');
        this.checkingIsPhoneRequiredCompleted(errorPhone, 1);
        this.specialAirportNotify("phone", ["remove"])
    }

    createPhone(phone:string, isPhoneRequired:boolean) {
        if (isPhoneRequired) {
            this.dto.pickupIndications.phoneRequired = this.phonePrefix + phone;
        } else {
            this.dto.pickupIndications.phoneOptional = phone ? this.phonePrefix + phone : "";
        }
    }

    specialAirportNotify(action, args) {
        let locationOid = this.dto.locationOid;
        if (this.specialPOS.isCancunAirport(locationOid) || this.specialPOS.isOrlandoAirport(locationOid)) {
            this.gaService.notify("Autos_" + this.specialPOS.getIataCode(locationOid) + "_Indications", action, args);
        }
    }

}



// WEBPACK FOOTER //
// ./public/upgrade/feature/additionalPoint/phone-component/phone.container.component.ts